var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wind-upload"},[_c('input',{ref:"uploadFile",staticClass:"wind-upload__input",attrs:{"type":"file","name":"file","accept":_vm.accept},on:{"change":_vm.onFileChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }